import { jsx as _jsx } from "react/jsx-runtime";
import { engLettersAndNumbersOnlyRegex, engLettersOnlyRegex, integerNumberRegex } from '@/core/utils/validation';
import { Autocomplete, Chip, TextField as MuiTextField } from '@mui/material';
import { forwardRef, useRef, useState } from 'react';
import { t } from '@/core/localization';
import { InfoTooltip } from '../InfoTooltip';
const CustomChipField = ({ numbersOnly = false, lettersOnly = false, lettersOrNumbersOnly = false, regex, restrictInputChangeMask: restrictInputMask, submitOnComma = false, submitOnSpace = false, placeholder, transformChipLabelValue, invalid, onChange, ...props }, ref) => {
    const [tooltipTitle, setTooltipTitle] = useState('');
    // We have to make inputValue being controlled to be able to clear this input inside custom onKeyDown.
    const [innerInputValue, setInnerInputValue] = useState('');
    // For validation on Enter press.
    const stateCopy = useRef([]);
    // TODO: to delete probably.
    const inputRef = useRef();
    return (
    // <ErrorTooltip arrow placement="bottom-start" open={tooltipOpen} title={tooltipTitle}>
    _jsx(InfoTooltip, { placement: "bottom-start", open: Boolean(tooltipTitle), title: tooltipTitle, children: _jsx(Autocomplete
        // autoHighlight can be used on MUI update, it is a fixed bug.
        // autoHighlight // Leads to a bug in onChange handler! Must not be used when options is [].
        , { 
            // autoHighlight can be used on MUI update, it is a fixed bug.
            // autoHighlight // Leads to a bug in onChange handler! Must not be used when options is [].
            multiple: true, freeSolo: true, ...props, ref: ref, clearText: t('delete.all'), options: [], renderValue: (value, getValueProps) => {
                return value?.map((option, index) => {
                    // Key value should be passed within `key` prop only. When it used with spread operator, react console error occurs.
                    const { key, ...tagProps } = getValueProps({ index });
                    const label = transformChipLabelValue?.(option) ?? option;
                    return _jsx(Chip, { variant: "outlined", size: "small", color: "primary", label: label, ...tagProps }, key);
                });
            }, renderInput: (params) => (
            // Only Mui TextFiled works inside Autocomplete, for some reason.
            _jsx(MuiTextField, { ...params, inputRef: inputRef, size: "small", placeholder: placeholder ?? t('enter.values.and.press.enter.to.confirm'), error: invalid })), onChange: (event, value) => {
                onChange(value);
                stateCopy.current = value;
            }, inputValue: innerInputValue, onInputChange: (event, newValue) => {
                // Can be used like this
                // // disallow 0-9
                //         if (/\d/.test(event.target.value)) {
                //           return event.preventDefault();
                //         }
                //         setInputValue(nextInputValue);
                if (restrictInputMask)
                    setInnerInputValue(newValue.replace(restrictInputMask, ''));
                else
                    setInnerInputValue(newValue);
            }, onKeyDown: (event) => {
                if (event.key !== 'Enter') {
                    // setTooltipOpen(false);
                    setTooltipTitle('');
                }
                if (event.code === 'Space') {
                    if (submitOnSpace) {
                        //console.log('in submitOnSpace, inputRef', inputRef);
                        //console.log('in submitOnSpace, inputRef.current: ', inputRef.current);
                        // TODO: it is not working because of this is not react synthetic event, but simple event.
                        inputRef.current.dispatchEvent(
                        //new KeyboardEvent('keypress', {
                        new KeyboardEvent('keydown', {
                            key: 'Enter',
                        }));
                    }
                    event.preventDefault();
                    return;
                }
                if (event.key === 'Enter' || (submitOnComma && event.key === ',') || (submitOnSpace && event.code === 'Space')) {
                    const value = event.target.value.trim();
                    if (value === '') {
                        event.defaultMuiPrevented = true;
                    }
                    else if ((stateCopy.current instanceof Array && stateCopy.current?.includes(value)) ||
                        stateCopy.current === value) {
                        // New mui version doesn't allow duplicated, to delete later.
                        // (BUT!) To handle MUIv7 bug (in onChange handler) we have to use it for now.
                        event.defaultMuiPrevented = true;
                        setTooltipTitle(t('entered.value.is.already.in.the.list'));
                    }
                    else if (numbersOnly && !integerNumberRegex.test(value)) {
                        event.defaultMuiPrevented = true;
                        setTooltipTitle(t('only.integers.are.allowed'));
                        //} else if (lettersOnly && !value.match(/^\p{Letter}+/gu)) {
                    }
                    else if (lettersOnly && !engLettersOnlyRegex.test(value)) {
                        event.defaultMuiPrevented = true;
                        setTooltipTitle(t('only.latin.letters.are.allowed'));
                        // } else if (regex && !value.match(regex.regExp)) {
                        // 	event.defaultMuiPrevented = true;
                        // 	setTooltipTitle(regex.errorMessage);
                        // }
                    }
                    else if (lettersOrNumbersOnly && !engLettersAndNumbersOnlyRegex.test(value)) {
                        event.defaultMuiPrevented = true;
                        setTooltipTitle(t('only.latin.letters.and.numbers.are.allowed'));
                    }
                    else if (regex) {
                        const regExpressions = regex.regExp instanceof Array ? regex.regExp : [regex.regExp];
                        let notMatch = true;
                        for (const regex of regExpressions) {
                            if (value.match(regex)) {
                                notMatch = false;
                                break;
                            }
                        }
                        if (notMatch) {
                            event.defaultMuiPrevented = true;
                            setTooltipTitle(regex.errorMessage); // TODO: use proper, extracted to const.
                        }
                        else {
                            if (regex.afterRegexCompletedConverter) {
                                event.defaultMuiPrevented = true;
                                const convertedValue = regex.afterRegexCompletedConverter(event.target.value);
                                // We have to check for duplicates one more time because of conversion.
                                if (Array.isArray(stateCopy.current) && stateCopy.current.includes(convertedValue)) {
                                    setTooltipTitle(t('entered.value.is.already.in.the.list'));
                                    return;
                                }
                                const newArray = [...props.value, convertedValue];
                                onChange(newArray);
                                stateCopy.current = newArray;
                                setInnerInputValue('');
                            }
                        }
                    }
                }
                // Prevent email <Chip> from being deleted on Backspace button press. Ctrl+Backspace works.
                else if (event.target.value === '' && event.key === 'Backspace' && !event.ctrlKey) {
                    event.defaultMuiPrevented = true;
                }
            } }) }));
};
const CustomChipFieldWithRef = forwardRef(CustomChipField);
export { CustomChipFieldWithRef as CustomChipField };
